export default __webpack_public_path__ + "static/geoguard-logo@2x-46e157804aeeeadfb1a4ccb61f0da2fb.png";